import { SelectData } from "@king-ict/eupisi-ui/components";
import { SchoolCandidateBatchDto } from "../../../../queries";
import { SchoolCandidateBatchStatus } from "../../../../models";
import { formatDate } from "../../../../utils/formatUtils";

export const generateSelectData = (
  batchData?: SchoolCandidateBatchDto[]
): SelectData<{ value: number; text: string }> => {
  return {
    keyProp: "value",
    valueProp: "value",
    textProp: "text",
    data:
      batchData?.map((batch) => ({
        value: batch.id,
        text: formatDate(batch.processedAt),
      })) ?? [],
  };
};

export const generateComboKey = (countyId: number, schoolYearId: number) =>
  `${countyId}-${schoolYearId}`;

export const generateInitialBatchStatusData = (
  batchStatus: SchoolCandidateBatchStatus | undefined
): SchoolCandidateBatchDto => {
  return {
    id: batchStatus?.batchId ?? 0,
    processedAt: batchStatus?.processedAt ?? "",
    schoolYearId: batchStatus?.schoolYearId ?? 0,
  };
};
